import React from 'react';
import { Table, message, Tag, DatePicker, Select, Button } from 'antd';
import { getCurrentUser, getStatusIcon, getChildren } from '../../../utils/utils';
import ActivityService from '../../../services/activity.service';
import { PARISH, MUNICIPALITY, LOGO } from '../../../utils/static-data';
import './all-activities.scss';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Option } = Select;

class AllActivities extends React.Component {

  createUserRef = React.createRef();

  state = {
    activities: [],
    filteredActivities: [],
    filters: {},
    visible: false,
    loading: false,
    userToEdit: null,
    user: getCurrentUser()
  }

  componentDidMount() {
    this.getActivities();
  }

  applyFilters = () => {
    let { filters, activities } = this.state;
    let filteredActivities = activities;

    Object.keys(filters).forEach(filter => {
      if (filter === 'gobernador') {
        filteredActivities = filteredActivities.filter(activity => this.handleGovernorPresentFilter(activity, filters.gobernador));
      } else if (filter === 'municipio') {
        const parishes = [];
        PARISH.forEach(p => { if (filters.municipio === p.municipality) { parishes.push(p.id); } });
        filteredActivities = filteredActivities.filter(activity => this.handleMunicipalityFilter(activity, parishes));
      } else if (filter === 'estatus') {
        filteredActivities = filteredActivities.filter(activity => this.handleStatusFilter(activity, filters.estatus));
      } else if (filter === 'date') {
        filters.date.length > 0 && (filteredActivities = filteredActivities.filter(activity => this.handleDateFilter(activity, filters.date)));
      }else if(filter === 'institucion') { 
        filteredActivities = filteredActivities.filter(activity => this.handleInstitutionFilter(activity, filters.institucion));
      } else {
        filteredActivities = activities;
      }
    });
    this.setState({ filteredActivities });
  }

  addFilter = (filter, origin) => {
    const { filters } = this.state;
    filters[origin] = filter;
  }

  handleDateFilter = (act, range) => {
    const start = moment(range[0]).unix();
    const end = moment(range[1]).unix();
    return (act.date >= start && act.date <= end);
  }

  handleInstitutionFilter = (act, institution) => {
    return (act.organism.id === institution);
  }

  handleMunicipalityFilter = (activity, parishes) => {
    return parishes.includes(activity.location);
  }

  handleStatusFilter = (activity, status) => {
    if (status === 0) {
      return true;
    } else {
      return activity.status === status;
    }
  }

  handleGovernorPresentFilter = (activity, present) => {
    if (present === 0) {
      return true;
    } else if (present === 1) {
      return activity.governor_present === false;
    } else {
      return activity.governor_present === true;
    }
  }

  getLocation = (location) => {
    const parish = PARISH.find((p) => p.id === location);
    const mun = MUNICIPALITY.find(m => m.id === parish.municipality);
    return `${parish.name || '-'} / ${mun.name || '-'}`
  }

  pdfList = () => {

    const { filteredActivities } = this.state;

    const mutation = filteredActivities.map(v => {
      return {
        title: v.title,
        date: new Date(v.date * 1000).toLocaleDateString(),
        organism: v.organism.name,
        location: this.getLocation(v.location),
        sector: v.sector
      }
    });

    const doc = new jsPDF('landscape');

    doc.autoTable({
      body: mutation,
      columns: [
        { header: 'Fecha', dataKey: 'date' },
        { header: 'Titulo', dataKey: 'title' },
        { header: 'Organismo', dataKey: 'organism' },
        { header: 'Lugar', dataKey: 'location' },
        { header: 'Sector', dataKey: 'sector' }
      ],
      margin: { top: 25, left: 5, right: 5, bottom: 5 },
      didDrawPage: (data) => {
        doc.setFontSize(14);
        doc.addImage(LOGO, 'png', data.settings.margin.left, 12, 10, 10);
        doc.text((data.settings.margin.left + 12), 20, doc.splitTextToSize(`LISTADO DE ACTIVIDADES`, 240));
      },
    });

    doc.save('listado.pdf');
  }

  getActivities = () => {
    const user = getCurrentUser();
    const organism = [1,4].includes(user.role) ? user.organism : 0;
    this.setState({ loading: true });
    ActivityService.getActivities(organism)
      .then(activities => {
        this.setState({ activities, loading: false, filteredActivities: activities });
      }, error => {
        message.error("Ha ocurrido un error al descargar actividades");
        this.setState({ loading: false });
      }).catch(error => {
        message.error("Ha ocurrido un error al descargar actividades");
        this.setState({ loading: false });
      });
  }

  rowClicked = (row) => {
    console.log(row);
  }

  render() {
    return (
      <div>
        <div className="usr-button-panel">
          <h2 style={{ fontWeight: 'lighter' }}>Listado de actividades</h2>
          <Button shape="circle" icon="printer" type="primary" onClick={this.pdfList} />
        </div>
        <div className="usr-button-panel">
          <RangePicker className="filter-input" onChange={(v) => this.addFilter(v, 'date')} />

          <Select className="filter-input" onSelect={(v) => this.addFilter(v, 'municipio')} style={{ width: '20%' }} placeholder="Municipio">
            {
              MUNICIPALITY.map((m, i) => (
                <Option key={i} value={m.id}>{m.name}</Option>
              ))
            }
          </Select>

          <Select className="filter-input" onSelect={(v) => this.addFilter(v, 'estatus')} style={{ width: '20%' }} placeholder="Estatus">
            <Option key="0" value={0}>Todas</Option>
            <Option key="1" value={1}>A reliazarse</Option>
            <Option key="2" value={2}>Realizada</Option>
            <Option key="3" value={3}>No realizada</Option>
          </Select>

          <Select className="filter-input" onSelect={(v) => this.addFilter(v, 'gobernador')} style={{ width: '20%' }} placeholder="Gobernador">
            <Option key="0" value={0}>Todas</Option>
            <Option key="1" value={1}>Ausente</Option>
            <Option key="2" value={2}>Presente</Option>
          </Select>

          <Select className="filter-input" onSelect={(v) => this.addFilter(v, 'institucion')} style={{ width: '30%' }} placeholder="Institución">
            {getChildren().map((child, i) => 
              <Option key={i} value={child.id}>{child.name}</Option>
              )}
          </Select>

          <Button type="primary" style={{ width: '15%' }} onClick={this.applyFilters}>Filtrar</Button>
        </div>
        <Table
          loading={this.state.loading}
          dataSource={this.state.filteredActivities}
          rowKey="id"
          columns={this.columns()}
          style={{ maxWidth: '100%' }}
          pagination={{ pageSize: 7 }}
          rowClassName="activity-row"
          onRow={(record) => ({ onClick: () => { this.rowClicked(record) } })}
        />
      </div>
    )
  }

  columns = () => {
    return [
      {
        title: 'Titulo',
        dataIndex: 'title',
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        render: (date) => new Date(date * 1000).toLocaleDateString()
      },
      {
        title: 'Institución',
        dataIndex: 'organism',
        render: (organism) => organism.name
      },
      {
        title: 'Lugar',
        dataIndex: 'location',
        render: (location) => {
          const parish = PARISH.find((p) => p.id === location);
          const mun = MUNICIPALITY.find(m => m.id === parish.municipality);
          return `${parish.name || '-'}, ${mun.name || '-'}`;
        }
      },
      {
        title: 'Sector',
        dataIndex: 'sector',
      },
      {
        title: 'Gobernador',
        dataIndex: 'governor_present',
        render: (governor_present) => {
          if (governor_present) {
            return <Tag color="green">Presente</Tag>
          }
          return <Tag color="red">Ausente</Tag>
        }
      },
      {
        title: 'Estado',
        dataIndex: 'status',
        render: (status) => getStatusIcon(status)
      }
    ]
  }

}

export default AllActivities;